import React from 'react';
import { useForm } from 'react-hook-form';
import { FORM_PAGES } from '../../../components/Form/types';
import FormInfo from '../../../components/FormInfo/CreatedAccount/FormInfo';
import { FORM_INFO_TYPES } from '../../../components/FormInfo/types';
import { vars } from '../../../reactive';
import { setFormPage } from '../../../reactive/actions';

const FormAccountInfo = () => {
  const { register, handleSubmit, setFocus } = useForm();
  const currentBranch = vars.currentBranch();
  const petTypes = currentBranch?.BranchTargeting?.pet_type;
  const isMoreThanOnePetType = petTypes.length > 1;
  const newPet = vars.newPet();

  const onSubmit = async () => {
    if (isMoreThanOnePetType) {
      setFormPage(FORM_PAGES.CREATE_PET_TYPE, 'fade-out');
    } else {
      vars.newPet({ ...newPet, type: petTypes[0] });
      setFormPage(FORM_PAGES.CREATE_PET_CREATE_PET);
    }
  };

  return (
    <FormInfo
      type={FORM_INFO_TYPES.CREATED_ACCOUNT}
      formOptions={{ register, handleSubmit, setFocus }}
      onSubmit={onSubmit}
      previousPage={{
        page: FORM_PAGES.PRODUCTS,
        animation: 'fade-out'
      }}
    />
  );
};

export default FormAccountInfo;
